import { render, staticRenderFns } from "./handWriting.vue?vue&type=template&id=16dd55fe&scoped=true"
import script from "./handWriting.vue?vue&type=script&lang=js"
export * from "./handWriting.vue?vue&type=script&lang=js"
import style0 from "./handWriting.vue?vue&type=style&index=0&id=16dd55fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dd55fe",
  null
  
)

export default component.exports